import { render, staticRenderFns } from "./NetRequire.vue?vue&type=template&id=d23b52a0&scoped=true&"
import script from "./NetRequire.vue?vue&type=script&lang=js&"
export * from "./NetRequire.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/project-infor-2020.css?vue&type=style&index=0&id=d23b52a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23b52a0",
  null
  
)

export default component.exports